var watchlistPositionList = {
	caption: "Volglijst Positielijst",
	name: "Naam",
	isin: "ISIN",
	lastPrice: "Laatste prijs",
	lastPriceDateTime: "Datum/Tijd",
	perf: "Verschil",
	perfRel: "Verschil %",
	volume: "Volume",
	tradingVolume: "Handelsvolume",
	exchange: "Markt",
	actions: "Acties",
	noPositions: "Geen resultaten gevonden"
};
var nl = {
	watchlistPositionList: watchlistPositionList
};

export { nl as default, watchlistPositionList };
